import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { scan } from 'rxjs/operators';
import { PortfoliosService } from 'src/app/core/services/portfolios/portfolios.service';
import { Helpers } from 'src/app/models/Helpers/helpers';
import { Portafoglio } from 'src/app/models/portafoglio';

@Component({
  selector: 'app-add-to-portafoglio-confirmation-dialog',
  templateUrl: './add-to-portafoglio-confirmation-dialog.component.html',
  styleUrls: []
})
export class AddToPortafoglioConfirmationDialogComponent implements OnInit {

  quantity: number;
  prezzoCertificato: string;
  isinDate: Date;
  portafoglio: Portafoglio;
  doubleFormatRegex = '^\\d+(\\.\\d+)?$';
  limit = 10;
  offset = 0;
  options = new BehaviorSubject<Portafoglio[]>([]);
  options$: Observable<string[]>;
  isPortafoglio: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    public portafoglioService: PortfoliosService,
    public dialogRef: MatDialogRef<string>
  ) {
    this.options$ = this.options.asObservable().pipe(
      scan((acc, curr) => {
        return [...acc, ...curr];
      }, [])
    );
  }

  ngOnInit(): void {
    this.getNextBatch();
    this.isPortafoglio = this.dialogData;
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  onYesClick(): void {
    this.dialogRef.close({
      quantity: this.quantity,
      prezzoCertificato: this.prezzoCertificato,
      isinDate: Helpers.convertDateToLocalFormat(this.isinDate),
      portafoglio: this.portafoglio
    });
  }

  getNextBatch() {
    const result = this.portafoglioService.userPortfolios.slice(this.offset, this.offset + this.limit);
    this.options.next(result);
    this.offset += this.limit;
  }

  isPrezzoCertificatoValido(): boolean {
    return parseFloat(this.prezzoCertificato) > 0;
  }
}
